/**
 * POI Module Entry Point  
 * Handles Points of Interest with interactive maps and filtering
 */

import POIManager from './manager.js';

export default class POIModule {
    constructor() {
        this.manager = null;
        
        this.init();
    }

    /**
     * Initialize POI module
     */
    init() {
        // Only initialize if we have POI components on the page
        if (!this.isPOIPage()) {
            return;
        }

        // console.log('Initializing POI Module');

        // Initialize POI manager
        this.manager = new POIManager();
        
        // Make manager globally accessible for backward compatibility
        window.poiListManager = this.manager;
    }

    /**
     * Check if current page has POI functionality
     */
    isPOIPage() {
        return POIManager.isAvailable();
    }

    /**
     * Get manager instance for external access
     */
    getManager() {
        return this.manager;
    }

    /**
     * Check if module is available on current page
     */
    static isAvailable() {
        return POIManager.isAvailable();
    }

    /**
     * Factory method to create instance only if needed
     */
    static createIfNeeded() {
        if (POIModule.isAvailable()) {
            return new POIModule();
        }
        return null;
    }
}
